import React from 'react'
import { URLS } from '../../../constants'
import { string } from 'prop-types'
import { Router } from '@reach/router'
import { CartaoCreditoProvider } from '../../../contexts/CartaoCreditoContext'
import TrocarFormaPagamento from './TrocarFormaPagamento/TrocarFormaPagamento'

import HomePix from './PagamentoPix'
import LazyComponent from '../../../components/LazyComponent/LazyComponent'

export default function Rotas( { modalidade } ) {
  const routePagamento = modalidade === 'MODALIDADE_CURADORIA' ? URLS.CURADORIA_PAGAMENTO : URLS.INEDITOS_PAGAMENTO

  return (
    <Router>
      <LazyComponent
        Component={ HomePix }
        currentRoute={ routePagamento }
        path="/"
      />

      <LazyComponent
        Component={ TrocarFormaPagamento }
        Context={ CartaoCreditoProvider }
        currentRoute={ routePagamento }
        path="/trocar-forma-pagamento"
      />
    </Router>
  )
}

Rotas.propTypes = {
  'modalidade': string.isRequired
}
